import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@material-ui/core";
import { CssTextField } from "./style";

export const LuckyDiceForm = ({
	classes,
	userId,
	setUserId,
	diceCount,
	setDiceCount,
}) => (
	<>
		<Typography variant="h6" className={classes.sectionTitle}>
			Add Lucky Dice
		</Typography>
		<div className={classes.inputRow}>
			<CssTextField
				className={classes.textField}
				label="User ID"
				variant="outlined"
				value={userId}
				onChange={(e) => setUserId(e.target.value)}
				required
			/>
			<CssTextField
				className={classes.textField}
				label="Number of Dice"
				variant="outlined"
				type="number"
				value={diceCount}
				onChange={(e) => setDiceCount(e.target.value)}
				error={
					diceCount &&
					(parseInt(diceCount, 10) <= 0 || parseInt(diceCount, 10) > 100)
				}
				helperText={
					diceCount && parseInt(diceCount, 10) <= 0
						? "Must be at least 1"
						: diceCount && parseInt(diceCount, 10) > 100
						? "At most 100 dice"
						: ""
				}
				InputProps={{ inputProps: { min: 1, max: 100 } }}
				required
			/>
		</div>
	</>
);

LuckyDiceForm.propTypes = {
	classes: PropTypes.object.isRequired,
	userId: PropTypes.string.isRequired,
	setUserId: PropTypes.func.isRequired,
	diceCount: PropTypes.string.isRequired,
	setDiceCount: PropTypes.func.isRequired,
};

export const validateLuckyDiceForm = ({ userId, diceCount }) => {
	return (
		userId &&
		diceCount &&
		parseInt(diceCount, 10) >= 1 &&
		parseInt(diceCount, 10) <= 100
	);
};
